import React from 'react';
import { useNavigate } from 'react-router-dom';
import ELayout from './ELayout';  

import { Button } from 'react-bootstrap';

const ELeaves = () => {
  const navigate = useNavigate();

  return (
    <ELayout heading="Leaves">
      <div className="container text-center mt-4">
        <div className="row justify-content-center">
          <div className="col-12 col-sm-10 col-md-8 col-lg-6 mb-3 d-flex flex-column flex-sm-row justify-content-center gap-3">
            <Button
              variant="primary"
              className="px-4 py-2 fw-bold shadow"
              onClick={() => navigate('/EHolidays')}
            >
              Public Holidays
            </Button>
            <Button
              variant="danger"
              className="px-4 py-2 fw-bold shadow"
              onClick={() => navigate('/leave')}
            >
              Request Leave
            </Button>
             <Button
              variant="success"
              className="px-4 py-2 fw-bold shadow"
              onClick={() => navigate('/wfh')}
            >
              Request WFH
            </Button>
          </div>
        </div>
      </div>
    </ELayout>
  );
};

export default ELeaves;
